import App from './App.vue';
import { router } from './router';
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
Vue.use(VueCompositionAPI);

// 初始化加载 dw
if (window.dw) {
  dw.setAppKey('d2c1a458c5aa631b');
  dw.setVersion('1.0.0');
  // 设置调试模式
  const isDwDebug = process.env.NODE_ENV === 'production' ? false : true;
  dw.setDebug(isDwDebug);
}

import 'element-ui/lib/theme-chalk/index.css';

// 注册公共样式
import '@/assets/scss/index.scss';

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app');


